import { UpdatableModel } from './updatable-model';
import { FirmLookup } from './firm-lookup';

export class FirmRelationship extends UpdatableModel<FirmRelationship> {
  successorFirm: FirmLookup;
  pastFirm: FirmLookup;
  type: string;
}
